import { type FileItem } from '../../models/files';
import { getUploadState } from '../files';

export function isUploadFailed(fileItem: FileItem): boolean {
  const uploadState = getUploadState(fileItem);
  return uploadState?.uploadStage === 'ERROR';
}
